import styled from "styled-components";

interface IListOptions {
  isVisible: boolean;
}

export const SelectContainer = styled.div`
  width: 100%;
  background-color: #fff;
  padding: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 5px;
`;

export const SelectBody = styled.div`
  width: 100%;
  position: relative;
`;

export const SelectButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  height: 35px;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  border-radius: 0.35rem;
  cursor: pointer;
  background-color: #fff;
  border: 1px solid ${({ theme }) => theme.colors.neutral.neutral20};
  color: ${({ theme }) => theme.colors.neutral.neutral40};
`;

export const SelectTitle = styled.span``;

export const OptionText = styled.span`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
`;

export const IconContainer = styled.span`
  flex-shrink: 0;
`;

export const ChipsContainer = styled.span`
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  min-width: 0;
  overflow: hidden;
`;

export const ChipsMedida = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  gap: 0.25rem;
  width: max-content;
  visibility: hidden;
  pointer-events: none;
`;

export const Chip = styled.span<{ $encolher?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: ${({ $encolher }) => ($encolher ? 1 : 0)};
  min-width: ${({ $encolher }) => ($encolher ? "40px" : "auto")};
  max-width: 160px;
  padding: 0.1rem 0.4rem;
  border-radius: 0.25rem;
  font-size: 0.8rem;
  white-space: nowrap;
  background-color: ${({ theme }) => theme.colors.project.bgColor};
  border: 1px solid ${({ theme }) => theme.colors.neutral.neutral20};
  color: ${({ theme }) => theme.colors.neutral.neutral90};
`;

export const ChipContador = styled(Chip)`
  flex-shrink: 0;
`;

export const ChipText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ChipRemove = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 0.65rem;
  color: ${({ theme }) => theme.colors.neutral.neutral40};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.neutral.neutral90};
  }
`;

export const OptionsList = styled.ul<IListOptions>`
  position: absolute;
  width: 100%;
  z-index: 100;
  margin-top: 0;
  margin-bottom: 0;
  border-radius: 0 0 0.5rem 0.5rem;
  padding: 0.25rem 0;
  background-color: #fff;
  border: 1px solid ${({ theme }) => theme.colors.neutral.neutral20};
  display: ${({ isVisible }) => isVisible ? 'block' : 'none'};
  max-height: 200px;
  overflow-y: auto;
`;

export const SearchItem = styled.li`
  list-style: none;
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0.25rem 0.5rem 0.35rem;
  background-color: #fff;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.neutral20};
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 30px;
  padding: 0 0.5rem;
  border-radius: 0.25rem;
  border: 1px solid ${({ theme }) => theme.colors.neutral.neutral20};
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.neutral.neutral90};

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.neutral.neutral40};
  }
`;

export const EmptyItem = styled.li`
  list-style: none;
  padding: 0.5rem;
  color: ${({ theme }) => theme.colors.neutral.neutral40};
  font-size: 0.875rem;
`;

export const ListItem = styled.li`
  padding: 0.15rem 0.25rem;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: start;
  cursor: pointer;
  gap: 0.5rem;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.project.bgColor};
  }
`;

export const Checkbox = styled.span`
  height: 14px;
  width: 14px;
  border-radius: 0.25rem;
  padding: 0.15rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.neutral.neutral20};
  font-size: 0.75rem;
`;

export const OptionsText = styled.span``;